export enum HittersRoutes {
  CreateHitter = 'create-hitter',
  DeleteHitters = 'delete-hitters',
  DeleteSessions = 'delete-sessions',
  GetHitters = 'get-hitters',
  GetHitterSession = 'get-hitter-session',
  GetMachineSessions = 'get-machine-sessions',
  UpdateHit = 'update-hit',
  UpdateHitter = 'update-hitter',
}
